export const OPEN_LIVE_METRICS = 'OPEN_LIVE_METRICS';
export const CLOSE_LIVE_METRICS = 'CLOSE_LIVE_METRICS';
export const FETCH_LIVE_METRICS = 'FETCH_LIVE_METRICS';
